import { ScrollReveal } from '@/components/shared/ScrollReveal'
import { productWorkflow, workflowGroups } from '@/content/portfolio'

export function ToolsDaily() {
  return (
    <section id="ai-workflows" className="scroll-mt-24 border-t border-vibe-border bg-vibe-black py-16 lg:py-24">
      <div className="mx-auto max-w-6xl px-4 lg:px-8">
        <ScrollReveal>
          <div className="max-w-3xl">
            <div className="section-label mb-3">How I work</div>
            <h2 className="text-3xl lg:text-5xl font-medium tracking-tighter text-text-heading">
              Product foundations. AI-assisted execution.
            </h2>
            <p className="mt-4 text-base lg:text-lg leading-relaxed text-text-secondary">
              I own the decisions and priorities. AI helps me prepare, build, and check the work.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal>
          <div className="mt-8 overflow-hidden rounded-2xl border border-vibe-border bg-card-bg">
            <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr]">
              <div className="p-5 lg:p-6">
                <h3 className="text-xl font-medium text-text-heading">Before AI</h3>
                <p className="mt-2 font-mono text-xs text-text-secondary">Linear / Jira · Notion / Confluence</p>
                <dl className="mt-6 space-y-5">
                  {productWorkflow.map((step) => (
                    <div key={step.task}>
                      <dt className="section-label mb-1">{step.task}</dt>
                      <dd className="text-sm leading-relaxed text-text-secondary">{step.before}</dd>
                    </div>
                  ))}
                </dl>
              </div>
              <div aria-hidden="true" className="flex items-center justify-center px-5 text-2xl text-accent-primary">
                <span className="hidden md:block">→</span>
                <span className="md:hidden">↓</span>
              </div>
              <div className="bg-accent-primary/5 p-5 lg:p-6">
                <h3 className="text-xl font-medium text-accent-primary">With AI</h3>
                <p className="mt-2 font-mono text-xs text-text-secondary">Same product practices, assisted by AI</p>
                <dl className="mt-6 space-y-5">
                  {productWorkflow.map((step) => (
                    <div key={step.task}>
                      <dt className="section-label mb-1">{step.task}</dt>
                      <dd className="text-sm leading-relaxed text-text-primary">{step.withAI}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          </div>
        </ScrollReveal>

        <h3 className="mt-12 text-xl font-medium text-text-heading">Workflows, pilots &amp; R&amp;D</h3>
        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {workflowGroups.map((group, index) => (
            <ScrollReveal key={group.title} delay={index * 0.04}>
              <article className="h-full rounded-2xl border border-vibe-border bg-card-bg p-5 lg:p-6">
                <h3 className="text-xl font-medium tracking-tight text-text-heading">{group.title}</h3>
                <p className="mt-2 text-sm text-text-muted">{group.description}</p>
                <div className="mt-6 space-y-5">
                  {group.items.map((item) => (
                    <div key={item.name} className="border-t border-vibe-border pt-4 first:border-0 first:pt-0">
                      <div className="flex flex-wrap items-start justify-between gap-2">
                        <h4 className="text-base font-medium text-text-primary">{item.name}</h4>
                        <span className="rounded-sm border border-vibe-border px-2 py-1 font-mono text-[10px] uppercase tracking-widest text-accent-primary">
                          {item.maturity}
                        </span>
                      </div>
                      <p className="mt-2 text-sm leading-relaxed text-text-secondary">{item.value}</p>
                    </div>
                  ))}
                </div>
              </article>
            </ScrollReveal>
          ))}
        </div>

      </div>
    </section>
  )
}
